module.exports = __webpack_public_path__ + "img/5.566fadbd.jpg";